import { Link } from 'react-router-dom';

const SUPPORT_EMAIL = 'support@imogenheap.com';

/**
 * `/contact` (#2078). The address is the owner's (2026-10-19). The heading is
 * the one the stub had; nothing else was added.
 *
 * The home link stays for the reason given on `StubPage`, which this page used
 * to be: #1867 hides the mobile nav for users who cannot use it, and
 * `/verify-email` sends people here.
 */
export function ContactPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-900">
          Contact Support
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="font-medium text-sky-600 hover:text-sky-500 transition-colors duration-200"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
        <Link
          to="/"
          className="mt-6 inline-block font-medium text-sky-600 hover:text-sky-500 transition-colors duration-200"
        >
          Go to the home page
        </Link>
      </div>
    </div>
  );
}
